export default "__VITE_ASSET__C1WLjnc___"